<template>
    <div>
        <el-table
                ref="shopMultipleTable"
                :data="$parent.orderCartShops"
                size="medium"
                v-show="$parent.shopClick"
                :height="($parent.$parentInfo.clientHeight-600+$parent.$parentInfo.heightChange)/$parent.row-$parent.cartTypeHeight"
                style="width: 100%"
                @selection-change="handleShopSelectionChange">
            <el-table-column
                    type="selection"
                    width="55">
            </el-table-column>
            <el-table-column
                    prop="name"
                    label="物品名"
                    width="260">
            </el-table-column>
            <el-table-column
                    prop="unit_price"
                    label="单价"
                    width="180">
            </el-table-column>
            <el-table-column
                    prop="discount"
                    label="折扣"
                    width="180">
            </el-table-column>
            <el-table-column
                    prop="amount"
                    label="数量"
                    width="100">
            </el-table-column>
            <el-table-column
                    prop="sum_price"
                    label="总价"
                    width="100">
            </el-table-column>
            <el-table-column
                    label="操作"
            >
                <template slot-scope="scope">
                    <el-dropdown trigger="click" size="medium">
                        <el-button icon="el-icon-edit" style="margin-right: 10px"> 编辑</el-button>
                        <el-dropdown-menu slot="dropdown">
                            <el-dropdown-item @click.native="handleDiscountShop(scope.row)">优惠信息</el-dropdown-item>
                        </el-dropdown-menu>
                    </el-dropdown>
                    <el-button icon="el-icon-delete" @click="handleDeleteCartShop(scope.row.id)"
                               :loading="$parent.$parentInfo.studentCart.button_loading">删除
                    </el-button>
                </template>
            </el-table-column>
        </el-table>
    </div>
</template>

<script>
    export default {
        name: "ShopCart",
        data() {
            return {

            }
        },
        computed: {

        },
        created() {

        },
        methods: {
            handleShopSelectionChange(val){
                this.$parent.shopMultipleSelection = val;
                let arr = [];
                for (let i in this.$parent.shopMultipleSelection) {
                    arr.push(this.$parent.shopMultipleSelection[i].id);
                }
                this.$parent.$parentInfo.studentCart.chosenShopCart = arr;
            },
            handleDiscountShop(cart_shop){
                this.$parent.$parentInfo.studentCart.dialog_DiscountShop.discountFilter.discount=cart_shop.discount
                this.$Win.openModal('Dialog_DiscountShop', 450, 400, '优惠', {
                    'cart_shop_id': cart_shop.id
                });
            },
            handleDeleteCartShop(id){
                this.$confirm('移除后将失去已设定的优惠信息，确定移除?', '提示', {
                    StartReturn: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.$parent.$parentInfo.studentCart.button_loading = true;
                    this.$wApi.send(this.$parent.$parentInfo.path, 'delete_shop_to_cart', {
                        'student_id': this.$parent.$parentInfo.student_id,
                        'cart_shop_id': id,
                    });
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消'
                    });
                });
            },
        }
    }
</script>

<style scoped>

</style>